/**
 * host: 服务器地址
 * port: 端口
 * projectname: 项目名称
 * urls: API接口
 */

var icp = module.exports = {
    host: 'http://39.108.181.226:',
    port: '8009',
    projectName: '',
    urls: {
        account_register: '/app/account/register',
        account_login: '/app/account/login',
        account_detail: '/app/account/detail',

        // 用户资料更新
        account_modify: '/app/account/modify',

        // 用户头像更新
        modify_header_img: '/app/account/modifyHeaderimg',

        // 用户防沉迷补填
        modify_id_card_and_realname: '/app/account/modifyIdCardAndRealname',

        // 用户绑定手机
        modify_mobile: '/app/account/modifyMobile',

        // 用户修改密码
        modify_password: '/app/account/modifyPassword',

        // 支付
        pay_create: '/app/pay/create',

        // 支付
        pay_result: '/app/pay/result',

        // 页面日志
        page_addLog: '/app/page/addLog',

        // 查看页面文字
        page_getContents: '/app/page/getContents'
    }
};



// WEBPACK FOOTER //
// ./src/lib/icp.js